import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { take, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AsyncJobActions, AsyncJobSelectors } from '@recruitee/async-job-data';
import { filterBoolean } from '@recruitee/common';

import { AsyncJobsDisplayController } from '../services/async-jobs-display.controller';

@Injectable({ providedIn: 'root' })
export class AsyncJobEffects {
  public jobStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AsyncJobActions.start),
        switchMap(({ payload: { job } }) =>
          this.store.select(AsyncJobSelectors.byId(job.uuid)).pipe(
            filterBoolean,
            take(1),
            tap(asyncJob => this.asyncJobController.onJobStart(asyncJob)),
          ),
        ),
      ),
    {
      dispatch: false,
    },
  );

  public jobFinish$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AsyncJobActions.finish),
        switchMap(({ payload: { job } }) =>
          this.store.select(AsyncJobSelectors.byId(job.uuid)).pipe(
            filterBoolean,
            take(1),
            tap(asyncJob => this.asyncJobController.onJobFinish(asyncJob)),
          ),
        ),
      ),
    {
      dispatch: false,
    },
  );

  constructor(
    private actions$: Actions,
    private asyncJobController: AsyncJobsDisplayController,
    private store: Store,
  ) {}
}
